import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/public/Home";
import Servicos from "@/pages/public/Servicos";
import Maquinas from "@/pages/public/Maquinas";
import Galeria from "@/pages/public/Galeria";
import Sobre from "@/pages/public/Sobre";
import Contato from "@/pages/public/Contato";
import AcompanharOrcamento from "@/pages/public/AcompanharOrcamento";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import Sheets from "@/pages/Sheets";
import Quotes from "@/pages/Quotes";
import QuoteNew from "@/pages/QuoteNew";
import QuoteDetail from "@/pages/QuoteDetail";
import Settings from "@/pages/Settings";
import GalleryAdmin from "@/pages/GalleryAdmin";
import Solicitacoes from "@/pages/Solicitacoes";
import SolicitacaoDetalhe from "@/pages/SolicitacaoDetalhe";
import Notificacoes from "@/pages/Notificacoes";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminPedidos from "@/pages/AdminPedidos";
import AdminServicos from "@/pages/AdminServicos";
import AdminMaquinas from "@/pages/AdminMaquinas";
import AdminPrecos from "@/pages/AdminPrecos";
import AdminProducao from "@/pages/AdminProducao";
import AdminFinanceiro from "@/pages/AdminFinanceiro";
import AdminContasPagar from "@/pages/AdminContasPagar";
import AdminUsuarios from "@/pages/AdminUsuarios";
import Layout from "@/components/Layout";
import ClientLayout from "@/components/ClientLayout";
import PortalDashboard from "@/pages/portal/Dashboard";
import OrcamentoNovo from "@/pages/portal/OrcamentoNovo";
import MeusOrcamentos from "@/pages/portal/MeusOrcamentos";
import Pedidos from "@/pages/portal/Pedidos";
import Perfil from "@/pages/portal/Perfil";

function Protected({ children, layout: Wrap = Layout }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-zinc-950 text-zinc-300">
        <div className="text-sm mono opacity-70">Inicializando…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Wrap>{children}</Wrap>;
}

const Portal = ({ children }) => <Protected layout={ClientLayout}>{children}</Protected>;

function AppRoutes() {
  const { user, ready } = useAuth();
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/servicos" element={<Servicos />} />
        <Route path="/maquinas" element={<Maquinas />} />
        <Route path="/estrutura" element={<Navigate to="/maquinas" replace />} />
        <Route path="/galeria" element={<Galeria />} />
        <Route path="/sobre" element={<Sobre />} />
        <Route path="/contato" element={<Contato />} />
        <Route path="/acompanhar" element={<AcompanharOrcamento />} />
        <Route path="/painel/orcamentos/novo" element={<div className="pt-[92px] pb-20 px-4 sm:px-6"><OrcamentoNovo /></div>} />
      </Route>

      <Route
        path="/login"
        element={ready && user ? <Navigate to={user.role === "admin" ? "/admin" : "/painel"} replace /> : <Login />}
      />

      {/* Área do cliente */}
      <Route path="/painel" element={<Portal><PortalDashboard /></Portal>} />
      <Route path="/painel/orcamentos" element={<Portal><MeusOrcamentos /></Portal>} />
      <Route path="/painel/pedidos" element={<Portal><Pedidos /></Portal>} />
      <Route path="/painel/perfil" element={<Portal><Perfil /></Portal>} />

      {/* Ferramenta interna (admin) */}
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/clientes" element={<Navigate to="/clientes-admin" replace />} />
      <Route path="/chapas" element={<Protected><Sheets /></Protected>} />
      <Route path="/orcamentos" element={<Protected><Quotes /></Protected>} />
      <Route path="/orcamentos/novo" element={<Protected><QuoteNew /></Protected>} />
      <Route path="/orcamentos/:id" element={<Protected><QuoteDetail /></Protected>} />
      <Route path="/configuracoes" element={<Protected><Settings /></Protected>} />
      <Route path="/galeria-admin" element={<Protected><GalleryAdmin /></Protected>} />
      <Route path="/solicitacoes" element={<Protected><Solicitacoes /></Protected>} />
      <Route path="/financeiro" element={<Protected><AdminFinanceiro /></Protected>} />
      <Route path="/financeiro/pagar" element={<Protected><AdminContasPagar /></Protected>} />
      <Route path="/solicitacoes/:id" element={<Protected><SolicitacaoDetalhe /></Protected>} />
      <Route path="/notificacoes" element={<Protected><Notificacoes /></Protected>} />
      <Route path="/clientes-admin" element={<Protected><Customers /></Protected>} />
      <Route path="/clientes-admin/:id" element={<Protected><CustomerDetail /></Protected>} />
      <Route path="/admin" element={<Protected><AdminDashboard /></Protected>} />
      <Route path="/pedidos-admin" element={<Protected><AdminPedidos /></Protected>} />
      <Route path="/servicos-admin" element={<Protected><AdminServicos /></Protected>} />
      <Route path="/maquinas-admin" element={<Protected><AdminMaquinas /></Protected>} />
      <Route path="/materiais-admin" element={<Navigate to="/precos-admin" replace />} />
      <Route path="/precos-admin" element={<Protected><AdminPrecos /></Protected>} />
      <Route path="/producao" element={<Protected><AdminProducao /></Protected>} />
      <Route path="/usuarios" element={<Protected><AdminUsuarios /></Protected>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster theme="dark" position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
